export default "__VITE_ASSET__BwKACxXj__"